import * as XLSX from 'xlsx';

import { ShamirSTInputRow } from '../../types';
import { getCellValue } from '../../utils';

const HEADER_LABEL = 'Nazwa';

export const parseShamirSTExcel = (file: ArrayBuffer): ShamirSTInputRow[] => {
    const workbook = XLSX.read(file, { type: 'array' });
    const sheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[sheetName];
    const rows = XLSX.utils.sheet_to_json<unknown[]>(worksheet, { header: 1, defval: '' });

    return rows
        .filter((row) => {
            const name = String(getCellValue(row, 1)).trim();

            return !!name && name !== HEADER_LABEL;
        })
        .map((row) => ({
            name: String(getCellValue(row, 1)).trim(),
            catalogNumber: getCellValue(row, 2) as number | string,
            buyPrice: Number(getCellValue(row, 3)),
            sellPrice: Number(getCellValue(row, 4)),
            sphMin: String(getCellValue(row, 5)).trim(),
            sphMax: String(getCellValue(row, 6)).trim(),
            cylMin: String(getCellValue(row, 7)).trim(),
            cylMax: String(getCellValue(row, 8)).trim(),
        }));
};
